export * from './shadow-type-3.component';